import { Col, Row } from "antd";
import { AvatarStackCta } from "@components/call-to-action";


interface PostAuthorsProps {
  className?: string;
  attrs?: any;
  data?: any[];
}

const defaultProps: PostAuthorsProps = {};

const PostAuthors = ({ className, data, attrs }: PostAuthorsProps) => {
  return (
    <Row justify="center" className={`${className}`}>
      {data?.map((author) =>
        <Col span={24}>
          <AvatarStackCta
            image={author.avatar}
            title={author.displayName}
            socialHandles={[]}
            email={author.email}
            website={author.website}
            roles={author.roles}
            subTitle={author.ID}
            link={{
              url: `mailto:${author.email}`,
              name: 'Contact',
              target: '_blank'
            }}
          />
        </Col>
      )}
    </Row>
  );
};

PostAuthors.defaultProps = defaultProps;

export default PostAuthors;
